module.exports = __webpack_public_path__ + "static/3-3ac18c2e05b5f69771561a2c720cfdbd.jpg";